import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions, ColorBatch } from 'components';
import { actionSearchTypesName, actionSearchTypesColorMap, dateTimeFormat, ACTION_STATUS, actionStatusName, actionStatusColorMap } from 'enums';
import { detailsBtn, recipientCellBox } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var actionCardRow = function actionCardRow(theme) {
  return {
    padding: '1.4em 1.6em',
    borderBottom: "1px solid ".concat(theme.gray100),
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: theme.gray50
    },
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '& .card-header': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.6em'
    },
    '& .card-borrower': {
      marginBottom: '0.8em',
      '& a': {
        fontWeight: 500,
        fontSize: '1.4rem',
        color: theme.gray700,
        '&:hover': {
          color: theme.primary
        }
      }
    },
    '& .card-note': {
      fontSize: '1.2rem',
      color: theme.gray400,
      marginBottom: '1em',
      lineHeight: 1.4
    },
    '& .card-metrics': {
      display: 'flex',
      gap: '1.2em',
      marginBottom: '1em',
      flexWrap: 'wrap'
    },
    '& .card-footer': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: '0.8em',
      borderTop: "1px solid ".concat(theme.gray100)
    },
    '& .card-action': {
      flexShrink: 0
    }
  };
};

var cardMetric = function cardMetric(theme) {
  return {
    flex: '1 1 80px',
    minWidth: 80,
    '& .metric-label': {
      display: 'block',
      fontSize: '1.1rem',
      color: theme.gray400,
      marginBottom: '0.2em',
      fontWeight: 500
    },
    '& .metric-value': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1.36rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};

var cardMeta = function cardMeta(theme) {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1em',
    fontSize: '1.15rem',
    color: theme.gray400,
    '& span': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.3em'
    },
    '& i': {
      fontSize: '1.3rem'
    }
  };
};

var followUpStyle = function followUpStyle(isOverdue) {
  return {
    color: isOverdue ? '#dc2626' : '#059669',
    fontWeight: isOverdue ? 600 : 400
  };
};

var renderActions = function renderActions(action) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onComplete = _ref.onComplete,
      onSnooze = _ref.onSnooze;

  var isActive = !action.status || action.status === ACTION_STATUS.active;
  var isSnoozed = action.status === ACTION_STATUS.snoozed;
  return ___EmotionJSX(TableActions, {
    mainAction: {
      linkTo: {
        pathname: "/actions/details/".concat(action === null || action === void 0 ? void 0 : action.id),
        state: {
          action: action
        }
      },
      leftIcon: {
        iconName: 'la la-info',
        size: 20
      },
      css: detailsBtn
    },
    actionsList: [(isActive || isSnoozed) && onComplete && {
      label: 'Завърши',
      icon: {
        iconName: 'la la-check-circle'
      },
      onClick: function onClick() {
        return onComplete(action.id);
      }
    }, isActive && onSnooze && {
      label: 'Отложи',
      icon: {
        iconName: 'la la-clock'
      },
      onClick: function onClick() {
        return onSnooze(action.id);
      }
    }]
  });
};

export var actionsListColumns = function actionsListColumns() {
  var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [{
    name: 'Проследяване',
    render: function render(_ref2) {
      var follow_up_date = _ref2.follow_up_date;
      if (!follow_up_date) return '—';
      var isOverdue = new Date(follow_up_date) <= new Date();
      return ___EmotionJSX("span", {
        style: followUpStyle(isOverdue)
      }, new Date(follow_up_date).toLocaleDateString('bg-BG'), isOverdue && ' ●');
    },
    flex: '0 0 120px'
  }, {
    name: 'Действие',
    render: function render(_ref3) {
      var action = _ref3.action;
      return ___EmotionJSX(ColorBatch, {
        type: actionSearchTypesColorMap[action]
      }, actionSearchTypesName[action]);
    },
    flex: '0 0 120px'
  }, {
    name: 'Детайли',
    render: function render(_ref4) {
      var borrower = _ref4.borrower,
          credit = _ref4.credit;
      return ___EmotionJSX("div", {
        css: recipientCellBox
      }, borrower ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Link, {
        to: "borrowers/details/".concat(borrower === null || borrower === void 0 ? void 0 : borrower.id_number)
      }, borrower === null || borrower === void 0 ? void 0 : borrower.first_name, " ", borrower === null || borrower === void 0 ? void 0 : borrower.middle_name, " ", borrower === null || borrower === void 0 ? void 0 : borrower.last_name), ___EmotionJSX("p", null, borrower === null || borrower === void 0 ? void 0 : borrower.id_number)) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", null, " \u041A\u0440\u0435\u0434\u0438\u0442 \u2116:"), ___EmotionJSX(Link, {
        to: "credits/details/".concat(credit === null || credit === void 0 ? void 0 : credit.id)
      }, credit === null || credit === void 0 ? void 0 : credit.number)));
    },
    flex: '1 1 140px'
  }, {
    name: 'Описание',
    render: function render(_ref5) {
      var note = _ref5.note;
      return note ? "".concat(note.slice(0, 50)).concat(note.length > 50 ? '...' : '') : '—';
    },
    flex: '1 1 120px'
  }, {
    name: 'Дата',
    value: 'created_at',
    dateTimeFormat: dateTimeFormat,
    flex: '0 0 130px'
  }, {
    name: 'Служител',
    value: 'employee.name',
    flex: '0 0 140px'
  }, {
    name: 'Статус',
    render: function render(_ref6) {
      var status = _ref6.status;
      var s = status || ACTION_STATUS.active;
      return ___EmotionJSX(ColorBatch, {
        type: actionStatusColorMap[s]
      }, actionStatusName[s]);
    },
    flex: '0 0 100px'
  }, {
    name: '',
    render: function render(action) {
      return renderActions(action, callbacks);
    },
    flex: '0 0 80px'
  }].filter(Boolean);
}; // --- Mobile/Tablet card row renderer ---

export var actionCardRenderer = function actionCardRenderer() {
  var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (_ref7) {
    var row = _ref7.row;
    var id = row.id,
        follow_up_date = row.follow_up_date,
        action = row.action,
        note = row.note,
        status = row.status,
        borrower = row.borrower,
        credit = row.credit,
        employee = row.employee,
        created_at = row.created_at;
    var isOverdue = follow_up_date && new Date(follow_up_date) <= new Date();
    var s = status || ACTION_STATUS.active;
    return ___EmotionJSX("div", {
      css: actionCardRow,
      key: id
    }, ___EmotionJSX("div", {
      className: "card-header"
    }, ___EmotionJSX("div", {
      style: {
        display: 'flex',
        gap: '0.5em',
        alignItems: 'center'
      }
    }, ___EmotionJSX(ColorBatch, {
      type: actionSearchTypesColorMap[action]
    }, actionSearchTypesName[action]), ___EmotionJSX(ColorBatch, {
      type: actionStatusColorMap[s]
    }, actionStatusName[s])), follow_up_date && ___EmotionJSX("span", {
      style: followUpStyle(isOverdue)
    }, new Date(follow_up_date).toLocaleDateString('bg-BG'), isOverdue && ' ●')), ___EmotionJSX("div", {
      className: "card-borrower"
    }, borrower ? ___EmotionJSX(Link, {
      to: "borrowers/details/".concat(borrower === null || borrower === void 0 ? void 0 : borrower.id_number)
    }, borrower === null || borrower === void 0 ? void 0 : borrower.first_name, " ", borrower === null || borrower === void 0 ? void 0 : borrower.middle_name, " ", borrower === null || borrower === void 0 ? void 0 : borrower.last_name) : credit ? ___EmotionJSX(Link, {
      to: "credits/details/".concat(credit === null || credit === void 0 ? void 0 : credit.id)
    }, "\u041A\u0440\u0435\u0434\u0438\u0442 \u2116: ", credit === null || credit === void 0 ? void 0 : credit.number) : null), note && ___EmotionJSX("div", {
      className: "card-note"
    }, note.slice(0, 100), note.length > 100 ? '...' : ''), created_at && ___EmotionJSX("div", {
      className: "card-metrics"
    }, ___EmotionJSX("div", {
      css: cardMetric
    }, ___EmotionJSX("span", {
      className: "metric-label"
    }, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("span", {
      className: "metric-value"
    }, new Date(created_at).toLocaleDateString('bg-BG')))), ___EmotionJSX("div", {
      className: "card-footer"
    }, ___EmotionJSX("div", {
      css: cardMeta
    }, employee && ___EmotionJSX("span", null, ___EmotionJSX("i", {
      className: "las la-user"
    }), " ", employee === null || employee === void 0 ? void 0 : employee.name)), ___EmotionJSX("div", {
      className: "card-action"
    }, renderActions(row, callbacks))));
  };
};